import React, { useState, useEffect } from "react";
import { motion } from "framer-motion/dist/framer-motion";
import cx from "classnames";
import _ from "lodash";

import award2 from "../../../assets/images/sbs/award-2.png";
import award3 from "../../../assets/images/sbs/award3.png";
import awardIcon from "../../../assets/images/sbs/award.png";
import crossIcon from "../../../assets/images/ttl/cross.png";
import { removeUser } from "../../../components/shared/utils";

const Leaderboard = ({
  users,
  roomId,
  status,
  player_scores,
  player_guesses,
  ttl_guessing_params,
}) => {
  const leaderboard_text = _.get(
    ttl_guessing_params,
    "leaderboard_text",
    "Leaderboard"
  );
  const [userData, setUserData] = useState([]);

  console.log(userData, "userDatauserDatauserData");

  useEffect(() => {
    let usersArray = [];
    let scores_array = [...player_scores];
    scores_array.sort((a, b) =>
      a.player_id > b.player_id ? 1 : b.player_id > a.player_id ? -1 : 0
    );

    for (let i = usersArray.length; i < users.length; i++) {
      usersArray = [
        ...usersArray,
        {
          ...scores_array[i],
          display_name: users[i].display_name,
          profile_image: users[i].profile_image,
        },
      ];
    }
    if (player_guesses.length !== 0) {
      for (let i = 0; i < player_guesses.length; i++) {
        usersArray = [
          ...usersArray.map((user) => {
            if (player_guesses[i].player_id === user.player_id) {
              return { ...user, guess: true };
            } else {
              return user;
            }
          }),
        ];
      }
    }
    usersArray = usersArray?.sort((a, b) =>
      a.score < b.score ? 1 : b.score < a.score ? -1 : 0
    );
    for (let i = 0; i < usersArray.length; i++) {
      if (i === 0) {
        usersArray[i].rank = 1;
      } else {
        if (usersArray[i].score === usersArray[i - 1].score) {
          usersArray[i].rank = usersArray[i - 1].rank;
        } else {
          usersArray[i].rank = i + 1;
        }
      }
    }
    setUserData(usersArray);
    console.log(usersArray, "usersArrayusersArrayusersArray");
  }, [player_scores, player_guesses]);

  const delPlayer = (data) => {
    const roomObj = { id: roomId };
    removeUser(roomObj, data);
  };

  const bounceRightGuessingVariants = {
    hidden: { x: "100vw" },
    visible: { x: 0 },
  };
  const bounceRightOverVariants = {
    exit: { x: "100vw" },
  };

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={
        status === "Over"
          ? bounceRightOverVariants
          : bounceRightGuessingVariants
      }
      className="ttl-leaderboard-card"
    >
      <h1 className="title">{leaderboard_text}</h1>
      <div className="leaderboard-players">
        {userData.length !== 0 &&
          userData?.map((user, index) => (
            <div
              key={index}
              className={cx("player-card", {
                active: !!user?.guess,
              })}
            >
              <div className="player-info">
                {user.rank > 3 ? (
                  <div className="sorted-num">
                    <p className="num">{index + 1}</p>
                  </div>
                ) : (
                  <img
                    alt=""
                    className="award-icon"
                    src={
                      user.rank === 1
                        ? awardIcon
                        : user.rank === 2
                        ? award2
                        : award3
                    }
                  />
                )}
                <img src={user?.profile_image} className="user-icon" alt="" />
                <p className="name"> {user?.display_name}</p>
              </div>
              <div className="player-points">
                <p className="pts">{user.score}</p>
                <img
                  alt=""
                  src={crossIcon}
                  className="cross-image"
                  onClick={() => delPlayer(user)}
                />
              </div>
            </div>
          ))}
      </div>
    </motion.div>
  );
};

export default Leaderboard;
